






































































































import { Component, Vue } from "vue-property-decorator";
import Base from "@/template/public/Base.vue";
import { Loading, Swipe, SwipeItem, Image as vanImage } from "vant";
import NewsItem from "@/components/NewsItemJiangjin.vue";
import request from "@/api/jiangjin/index";
import native from "@/common/Native";
import { Base64 } from "js-base64";
import AppPrompt from "@/components/AppPrompt.vue";
import { ISpecialDetail, IInfoThemeDetails } from "@/api/wanzhou/types";
import { wxChatShare } from "@/common/wechat";

@Component({
  components: {
    NewsItem,
    [Loading.name]: Loading,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    AppPrompt,
    vanImage
  }
})
export default class SpecialTopicPage extends Base {
  private specialDetail: any = {};
  newsList: Array<any> = [];
  public infoClassifyId: string = "";
  public request = new request();
  public appId: string = "";

  swiperData: any[] = [];
  current: number = 0;

  mounted() {
    this.infoClassifyId = this.$route.query.id
      ? (this.$route.query.id as string)
      : (this.$route.query.cid as string) || "2435342";
    this.appId = (this.$route.query.appId as string) || "";
    this.getDetail();
    this.getList();
  }

  getDetail() {
    this.request
      .getTopicManage({
        appId: this.appId,
        infoClassifyId: this.infoClassifyId
      })
      .then(async res => {
        if (res.code >= 0) {
          this.specialDetail = res.data;
          //设置title
          document.title = this.specialDetail.title;
          this.swiperData = res.data.infoClassifyDtos
            ? res.data.infoClassifyDtos
            : [];
          await this.getShareInfo(String(this.specialDetail.appId));
          let imgUrl = this.specialDetail.listImgUrl
            ? this.specialDetail.listImgUrl.split(",")[0]
            : this.shareInfo.shareLogo;
          wxChatShare(
            this.specialDetail.title,
            this.specialDetail.synopsis,
            window.location.href,
            imgUrl
          );
        }
      });
  }
  getList() {
    this.request
      .getTopicClassificationList({
        appId: this.appId,
        infoClassifyId: this.infoClassifyId
      })
      .then(res => {
        if (res.code >= 0) {
          this.newsList = res.data;
        }
      });
  }

  onChange(index: number) {
    this.current = index;
  }

  //跳转热点详情
  newItemClick(item: any) {
    if (native.isOpenInApp()) {
      native.openWebBrowser({
        id: item.id,
        sourceId: item.informationId,
        detailViewType: item.detailViewType,
        sourceType: item.sourceType,
        commentType: item.commentType,
        contextType: item.contextType,
        isShowTop: "1",
        isShowBottom: "1",
        isShowMore: "1",
        url: item.url,
        shareUrl: item.shareUrl,
        title: Base64.encode(item.title), //base 64
        synopsis: Base64.encode(item.synopsis), //base 64
        shareImgUrl: item.shareImgUrl,
        videoFormat: item.videoFormat ? item.videoFormat : ""
      });
    } else {
      // 分享出去 外链新闻增加浏览量的操作（因为无法在详情中增加浏览量）
      if (item.sourceType == 1) {
        // 外链
        this.request.getCount(this.appId, item.id);
      }
      window.location.href = item.url;
    }
  }

  toThemeDetail(item: any) {
    const url =
      window.location.href.split("#")[0] +
      "#/special/special-list?appId=" +
      this.appId +
      "&infoThemeName=" +
      item.themeName +
      "&infoThemeId=" +
      item.themeId +
      "&id=" +
      this.infoClassifyId;
    // const url = window.location.href.split('#')[0] + '#/ykblist/ykblist-page?' + '&app_Id=' + this.appId;
    if (native.isOpenInApp()) {
      this.switchUrl(url);
    } else {
      window.open(url);
    }
  }
  toThemeDetail2(item: any) {
    const url =
      window.location.href.split("#")[0] +
      "#/special/special-list?appId=" +
      this.appId +
      "&infoThemeName=" +
      item.name +
      "&infoThemeId=" +
      item.id +
      "&id=" +
      this.infoClassifyId;
    // const url = window.location.href.split('#')[0] + '#/ykblist/ykblist-page?' + '&app_Id=' + this.appId;
    if (native.isOpenInApp()) {
      this.switchUrl(url);
    } else {
      window.open(url);
    }
  }
  switchUrl(url: string) {
    ZWY_CLOUD.redirectUrl({
      id: "",
      sourceId: "",
      sourceType: "8",
      detailViewType: "98",
      commentType: "0",
      isShowBottom: "0",
      isShowMore: "0",
      isShowTop: "1",
      shareImgUrl: "",
      shareUrl: window.location.href,
      synopsis: Base64.encode(""),
      title: Base64.encode(""),
      url: encodeURI(url),
      contextType: "1"
    });
  }
}
